import AppLoading, {AppLoadError} from './app_loading';
import React from "react"
import { Helmet } from 'react-helmet-async';
import debounce from 'debounce'
import {withRouter} from "react-router-dom"
import NavbarContainer from "./navbar/navbar_container"
import PhotographerItem from "./photographers/photographer_item"
import PageHeader from "./page_header"
import Map from "./map"
import LogoSpinner from "../../../assets/images/landing/video-thumbnails/MA-logo-spinner-transparent.gif";
import { fetchPhotographersMap } from "../util/users_api_util"
import InviteModal from "./referrals/invite_modal"
import PhotographerCalendarModal from "./photographers/photographer_calendar_modal_conatiner"

class PhotographersIndex extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isLargeScreen: typeof window === 'undefined' ? true : window.innerWidth > 750,
      mapLoading:true, mapError:false,
      loading: false,
      zipcode: "",
      search: "",
      photographers: [],
      photographersMap: [],
      inviteModal: false,
      availabilityPhotographer: null,
    }
    this.updatePredicate = this.updatePredicate.bind(this)
    this.onZipCodeChange = this.onZipCodeChange.bind(this)
    this.onSearchChange = this.onSearchChange.bind(this)
    this.debounceSearch = debounce(this.search, 500)
    this.setInviteModal = this.setInviteModal.bind(this)
    this.debounceSearchText = debounce(this.searchText, 500)
    this.handler = this.handler.bind(this)
  }

  componentDidMount() {
    this.updatePredicate()
    window.addEventListener("resize", this.updatePredicate)

    this.loadPhotographerMap()
  }

  loadPhotographerMap = () => {
    this.setState({mapLoading:true,mapError:false})
    return fetchPhotographersMap().then(photographers => this.setState({photographersMap:this.shuffle(photographers),mapLoading:false})).catch(() => this.setState({mapLoading:false,mapError:true}))
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updatePredicate)
  }

  onZipCodeChange(e){
    if (e.currentTarget.value.length === 5){
      this.setState({ "zipcode": e.currentTarget.value, loading: true })
    } else {
      this.setState({ "zipcode": e.currentTarget.value })
    }
    this.debounceSearch(e.currentTarget.value, this.state.search)
  }

  onSearchChange(e){
    this.setState({search: e.currentTarget.value})
    this.debounceSearchText(e.currentTarget.value)
  }

  setInviteModal() {
    this.setState({ inviteModal: !this.state.inviteModal })
  }

  handler(newState) {
    if (newState.contractorCalendarOpen === false || newState.modalOpen === false) {
      newState.availabilityPhotographer = null
    }
    this.setState(newState)
  }

  updatePredicate() {
    this.setState({isLargeScreen: window.innerWidth > 750})
  }

  isAZipcode(zipcode){
    const zipRegex = /^\d{5}(-\d{4})?$/;
    return zipRegex.test(zipcode);
  }

  searchText(search){
    if (search != ""){
      let searchZipcode = null
      let searchText = null

      if ((search.length === 5 && this.isAZipcode(search))) {
        searchZipcode = search
      } else {
        searchText = search
      }

      this.setState({loading: true})

      this.props.fetchContractors(null, searchZipcode, searchText, true).then(photographers => this.setState({ loading: false, photographers: this.shuffle(Object.values(photographers.contractors)) }))
    }else{
      this.setState({ photographers: [] })
    }
  }

  search(zipcode, search) {
    if ((zipcode.length === 5 && this.isAZipcode(zipcode))){
      this.setState({ loading: true })
      this.props.fetchContractors(null, zipcode, search, true).then(photographers => this.setState({ loading: false, photographers: this.shuffle(Object.values(photographers.contractors)) }))
    } else if (zipcode.length === 0){
      if (search != ""){
        this.setState({ loading: true })
        this.props.fetchContractors(null, null, search, true).then(photographers => this.setState({ loading: false, photographers: this.shuffle(Object.values(photographers.contractors)) }))
      } else {
      this.setState({photographers: []})
      }
    }
  }

  shuffle = array => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      const temp = array[i];
      array[i] = array[j];
      array[j] = temp;
    }

    return array
  }

  render() {
    let modal = ""
    if (this.state.inviteModal){
      modal = <InviteModal setInviteModal={this.setInviteModal} photographerInvites={true} />
    }

    let availabilityModal = ""
    if (this.state.availabilityPhotographer) {
      const photographer = this.state.availabilityPhotographer
      const service = photographer.services?.filter(s => !s.twilight)[0]?.id || null
      availabilityModal = <PhotographerCalendarModal
        photographer={photographer}
        detected_timezone={photographer.timezone}
        selectedService={service}
        changeParentState={this.handler} />
    }

    return (
      <div className="dashboardFullPageDiv photographer-directory">
        <Helmet><title>Photographers</title></Helmet>
        {modal}
        {availabilityModal}
        <NavbarContainer/>
        <div className="dashboardMainDiv">
          <PageHeader title="Photographers"
                      subtitle="View all of our photographers"
                      showNotifications={true}/>
          <div className="sectionCard">
            {this.props.currentUser.roles.admin && <div className="photographerInviteButton"><button onClick={this.setInviteModal} className="projectEditButton dashboardReferralButton">Invite Photographers</button></div>}
            <div className="sectionCardHeader">
              <h5 className="photographersCardTitle">
                Photographer Portfolio
              </h5>
              <div className="photographersCardDescription">
                Below is a list of our photographers, view their profile to see their work.
              </div>
              <div className="photographerSearchGroup">
                {/* <div className="searchBarDiv photographersSearch">
                  <input className="formInput" onChange={this.onZipCodeChange} type="text"
                        placeholder="Property Zip Code" value={this.state.zipcode}/>
                </div> */}
                <div className="searchBarDiv photographersSearch">
                  <input className="formInput" onChange={this.onSearchChange} type="text"
                    placeholder="Search zipcode or name" value={this.state.search} />
                </div>
              </div>
            </div>
            {this.state.loading ? <div className="sectionCardBody">
              <div className="createProjectLogoSpinner">
                <img className="logoImageSpinnerGif" src={LogoSpinner}></img>
              </div>
            </div> : 
            <div className="sectionCardBody">
              <div className="photographersContainer">
                {this.state.photographers.map(photographer => {
                  return <PhotographerItem key={photographer.id} photographer={photographer} currentUser={this.props.currentUser} onAvailability={() => this.setState({ availabilityPhotographer: photographer })} />
                })}
                {this.state.photographers.length === 0 && this.state.zipcode === "" && <div className="photographerZipCodeDescription">Please enter a zipcode to view photographers in that area.</div>}
              </div>
              {Object.values(this.state.photographers).length === 0 && this.state.zipcode && this.state.zipcode.length === 5 && !this.state.loading && (
                <div className="photographersCardDescription mt-3">
                Oops, there aren't any photographers servicing the zip code your entered.
                Our team has been alerted! Please email <a href="mailto:info@modernangles.com">info@modernangles.com</a> for immediate assistance.
              </div>)}
           </div>
            }
            <div className="mapDashboardDiv mapDashboardDivPhotographer">
              <div className="mapDashboardcontents mapDashboardContentsPhotographer">
                {this.state.mapLoading ? <AppLoading label="Loading photographer map…" variant="map"/> : this.state.mapError ? <AppLoadError retry={this.loadPhotographerMap}/> : <Map contractors={this.state.photographers.length > 0 ? this.state.photographers : this.state.photographersMap} currentUser={this.props.currentUser} />}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(PhotographersIndex)
